module.exports = __webpack_public_path__ + "img/me.a871491c.png";